import Header from '../Header';
import Footer from '../Footer';
import { Outlet } from 'react-router-dom';
import ScrollTop from '../ScrollTop';

const Layout = () => {
  return (
    <div>
      <ScrollTop />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
